module.exports = __webpack_public_path__ + "media/images/fallback_link-cf7b7a2b19fd930ffa2ab6ce13f5addf.png";